<template>
    <div class="card tw-shadow tw-bg-white">
        <card-top :icon="icon" :text="title">
            <slot name="card-top"></slot>
        </card-top>
        <div class="card-inner tw-p-6">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Top from './Top.vue';
export default {
    name: 'ProfileCard',
    components: {
        'card-top': Top
    },
    props: ['icon', 'title'],
}
</script>

<style lang="scss" scoped>
.card-top {
    border-bottom: 1px solid #e3e3e3;
}
</style>